import React from 'react';

function WalletIcon03({ fill, ...restProps }) {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill={fill ?? ''}
      xmlns='http://www.w3.org/2000/svg'
      {...restProps}
    >
      <path
        d='M4.499 2.043C3.383 2.23 2.461 3.048 2.114 4.16l-.094.3v15.08l.094.3a3.086 3.086 0 0 0 2.046 2.046l.3.094h15.08l.3-.094a3.086 3.086 0 0 0 2.046-2.046l.094-.3V8.46l-.094-.3a3.089 3.089 0 0 0-2.025-2.039l-.321-.101L12.12 6 4.7 5.98l-.184-.108c-.581-.342-.683-1.098-.213-1.569.326-.326-.181-.303 6.734-.305 5.027-.001 6.17-.011 6.293-.055.221-.079.414-.241.539-.454.095-.161.111-.233.111-.489 0-.254-.017-.328-.108-.484a1.02 1.02 0 0 0-.582-.461c-.152-.046-1.235-.054-6.386-.05-3.412.002-6.295.02-6.405.038M4.22 7.91c.186.065.706.071 7.62.09 8.317.022 7.556-.009 7.877.321.3.31.283-.035.283 5.68 0 4.211-.01 5.138-.055 5.289a1.02 1.02 0 0 1-.461.582l-.184.108H4.7l-.184-.108a1.199 1.199 0 0 1-.291-.249c-.238-.312-.225.034-.225-6.128 0-3.11.005-5.655.01-5.655.006.001.1.032.21.07m11.729 4.707c-1.275.524-1.25 2.3.038 2.782.631.236 1.391-.015 1.767-.582.169-.256.224-.456.224-.817 0-.361-.055-.561-.224-.817-.383-.578-1.173-.826-1.805-.566'
        fill-rule='evenodd'
        fill={fill ?? ''}
      />
    </svg>
  );
}

export default WalletIcon03;
